export default "__VITE_ASSET__CVMIlUnU__"